import api from '@/libs/axios'
import { addOrUpdateInList, cleanEntityToSend } from '../../utils/form'
import Vue from 'vue'
import ToastificationContent from '@/components/toastification/ToastificationContent.vue'
import { capitalize } from '@/utils/filter'
import i18n from '@/libs/i18n'
import useAppConfig from '../../utils/useAppConfig'
import store from '../index'
import useAPI from '../../utils/useAPI'

export default {
  // Payload : page, perPage, searchCriteria, sortColumn, sortOrder
  getSocialSecurityContributions ({ commit, state }, payload) {
    const { performApiCall } = useAPI()
    store.commit('app/TOGGLE_LOADING', true)

    return new Promise((resolve, reject) => {
      let url = '/socialSecurityContributions2'

      performApiCall(url, payload)
        .then(response => {
          commit('SET_SOCIALSECURITYCONTRIBUTIONS', response.data.results)
          commit('SET_SOCIALSECURITYCONTRIBUTIONSCONTEXT', response.data.page_context)
          store.commit('app/TOGGLE_LOADING', false)
          resolve(true)
        })
    })
  },
  getSocialSecurityContribution ({ commit, state }, chargeId) {
    store.commit('app/ADD_LOADER')

    return new Promise((resolve, reject) => {
      api.get('/socialSecurityContributions/'+chargeId)
        .then(response => {
          addOrUpdateInList(response.data, state.socialSecurityContributions, 'socialSecurityContribution',commit)

          store.commit('app/REMOVE_LOADER')
          resolve(response.data)

        })
        .catch(err => {
          console.log('Error', err)
          reject(err)
        })
    })
  },
  async addSocialSecurityContribution ({ commit, state }, socialSecurityContribution) {
    return await cleanEntityToSend(socialSecurityContribution, state.params)
      .then(async clonedEntityToSend => {
        return new Promise((resolve, reject) => {
          api.post('/socialSecurityContributions', clonedEntityToSend)
            .then(response => {
              commit('ADD_SOCIALSECURITYCONTRIBUTION', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The social security contribution has been ', { crud: i18n.t('createdE') }),
                  variant: 'success'
                },
              })

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  async updateSocialSecurityContribution ({ commit, state }, socialSecurityContribution) {
    return await cleanEntityToSend(socialSecurityContribution, state.params)
      .then(async clonedEntityToSend => {

        return new Promise((resolve, reject) => {
          api.put('/socialSecurityContributions/' + socialSecurityContribution.id, clonedEntityToSend)
            .then(response => {
              commit('UPDATE_SOCIALSECURITYCONTRIBUTION', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The social security contribution has been ', { crud: i18n.t('editedE') }),
                  variant: 'success'
                },
              })

              resolve(response)
              // resolve(JSON.parse(JSON.stringify(response)))
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  removeSocialSecurityContribution ({ commit }, socialSecurityContribution) {
    return new Promise((resolve, reject) => {
      api.delete('/socialSecurityContributions/' + socialSecurityContribution.id)
        .then(response => {
          commit('REMOVE_SOCIALSECURITYCONTRIBUTION', socialSecurityContribution)

          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: capitalize(i18n.t('success')),
              icon: 'check',
              text: i18n.t('The social security contribution has been ', { crud: i18n.t('removedE') }),
              variant: 'success'
            },
          })

          resolve(response)
        })
        .catch(error => {
          console.log('Error', error)
          reject(error)
        })
    })
  },

}